export default __webpack_public_path__ + "static/ceriani-eaf1fb4ede9917f323f51f91e54098d4.jpeg";